import { useState, useEffect } from 'react';
import { talentAPI, Talent, TalentKategori } from '@/services/api';

export const useOppmoteTalents = () => {
  const [allTalents, setAllTalents] = useState<Talent[]>([]);
  const [allKategorier, setAllKategorier] = useState<TalentKategori[]>([]);

  useEffect(() => {
    const fetchAllTalents = async () => {
      try {
        const [talenterData, kategorierData] = await Promise.all([
          talentAPI.getAll(),
          talentAPI.getAllKategorier(),
        ]);
        setAllTalents(talenterData.talenter);
        setAllKategorier(kategorierData.kategorier);
      } catch (err) {
        console.error('Feil ved henting av alle talenter:', err);
      }
    };

    fetchAllTalents();
  }, []);

  return { allTalents, allKategorier };
};

